export const stakingAddress = "0x4bceceAa5CdB0B2a5C07878B276C96F267F65194";
export const tokenAddress = "0x3b76374Cc2DfE28Cc373DcA6d5024791B2586335";

// export const stakingAddress = "0x6F4480419492562D592e451a99236af998ce547C";
// export const tokenAddress = "0x52C2c95822100298Dc090EbB1DB7Cb6a70849d28";
